<div>
  <div class="modal-header">
    <i class="fa fa-close" (click)="activeModal.close()" style="float:right; cursor: pointer;"></i>
    <h4 style="margin-bottom: 0;"><i class="fa fa-check"></i> Please Confirm</h4>

  </div>
  <div class="modal-body" [innerHTML]="text">

  </div>
  <div class="modal-footer">
          <button class="btn btn-primary" (click)="activeModal.close()">Yes</button>
          <button class="btn btn-warning" (click)="activeModal.dismiss()">No</button>
  </div>
</div>

